import React from 'react';
import Box from 'ui/Box/Box';
import Flex from 'ui/Flex/Flex';
import Header from 'Components/Header/Header';
import heroVideo from './hero_animation.mp4';
import Styles from './HeroSection.module.scss';
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
  const navigate = useNavigate();

  return (
    <Box
      as="section"
      id="HeroSection"
      direction="column"
      gap="48"
      color="sunset"
      margins
      css={{ padding: '12px', marginTop: '-8px' }}
    >
      <Header />
      <Flex direction="column" align="center" gap="32">
        {/* banner content */}
        <Flex
          direction="column"
          align="center"
          gap="16"
          css={{ textAlign: 'center' }}
          className={Styles.Banner}
        >
          <h1 className={Styles.banner_header}>
            Plan and Generate 30 Days of{' '}
            <span
              style={{
                whiteSpace: 'nowrap',
              }}
            >
              Multi-Channel
            </span>{' '}
            Content With One Click
          </h1>
          <p className={Styles.baner_description}>
            Just enter your goal or topics, select your channel(s), and Vocable
            instantly generates a complete 30-day content campaign with
            ready-to-review copy for LinkedIn, blogs, social media, and
            more—tailored specifically to your business.
          </p>
        </Flex>
        {/* banner buttons */}
        <Flex
          align="center"
          gap="24"
          css={{ fontWeight: 600 }}
          className={Styles.mobile_watch_started}
        >
          <button
            className={Styles.watch_demo__get_started_btn}
            onClick={() => navigate('sign-up')}
          >
            Start Your Free Trial
          </button>
          <a
            href="https://www.youtube.com/watch?v=HHfUctTA4mo"
            target="_blank"
            className={Styles.watch_demo}
          >
            <span>Watch our demos</span>
          </a>
        </Flex>
      </Flex>
      {/* banner video */}
      <div className={Styles.banner_ticker_video}>
        <div className={`${Styles.banner_video}`}>
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: '100%',
              objectFit: 'contain',
              borderRadius: '20px',
            }}
            src={heroVideo}
          />
        </div>
      </div>
    </Box>
  );
};

export default HeroSection;
